import { EBannerSize } from '@/app/models/banners.model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { environment } from '@environments/environment';
import { NoResultComponent } from '../../../no-result/no-result.component';
import { SkeletonBannerComponent } from '../../../skeleton';
import { PreRenderCalendarComponent } from '../pre-render-calendar/pre-render-calendar.component';

@Component({
  selector: 'app-pre-render-left-menu',
  standalone: true,
  imports: [
    CommonModule,
    PreRenderCalendarComponent,
    SkeletonBannerComponent,
    NoResultComponent,
  ],
  templateUrl: './pre-render-left-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderLeftMenuComponent {
  isfloating = input<boolean>(false);
  urlIcon = environment.urlIcon;
  firstSizeBanner = EBannerSize.VERTICAL_BANNER;
}
